import React from "react";
import PropTypes from "prop-types";

import styles from "./index.scss";

export default class Loading extends React.PureComponent {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    mask: PropTypes.bool,
    delay: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    //延迟DELAY展示
    this.setLoadingTimer();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.visible !== this.state.visible) {
      //visible变更时，触发定时loading
      this.setLoadingTimer();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  setLoadingTimer = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.setState({
        visible: this.props.visible,
      });
      clearTimeout(this.timer);
    }, this.props.delay);
  };

  renderLoading = () => {
    const { mask } = this.props;
    const { visible } = this.state;
    if (visible) {
      if (mask) {
        return (
          <div className={styles["al-loading"]}>
            <div className={styles["al-loading-mask"]}>
              <div className={styles["al-loading-content"]}>
                <span className={styles["loading"]} />
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className={styles["al-loading-content"]}>
            <span className={styles["loading"]} />
          </div>
        );
      }
    } else {
      return null;
    }
  };

  render() {
    return this.renderLoading();
  }
}

Loading.defaultProps = {
  mask: true,
  visible: false,
  delay: 500,
};
